import React from 'react';

import {SimpleCalculatorTableCell} from '../components/calculators/SimpleCalculatorTable';
import Select from '../components/Select';
import {STORAGE_CROPS, StorageCropId} from '../decision/data/storageAshTransport';

export const CALCULATOR_PARAMS = {
  populate: [
    'calculator',
    'calculator.resources',
    'calculator.resources.image',
    'calculator.resources.author',
    'calculator.resources.category',
  ],
} as const;

export const CALCULATOR_PROCESS_DATA_MAP = {
  calculator: {
    resources: {
      image: 'image',
      date: 'date',
      author: 'commonChild',
      category: 'commonChild',
    },
  },
} as const;

export function buildSimpleCalculatorTableRow(args: {
  leftContent: SimpleCalculatorTableCell['content'];
  rightContent: SimpleCalculatorTableCell['content'];
  border?: SimpleCalculatorTableCell['borderL'];
  type?: SimpleCalculatorTableCell['type'];
}): [SimpleCalculatorTableCell, SimpleCalculatorTableCell] {
  return [
    {
      content: args.leftContent,
      borderL: args.border,
    },
    {
      content: args.rightContent,
      borderR: args.border,
      type: args.type,
    },
  ];
}

const storageCropOptions = Object.entries(STORAGE_CROPS).map(([cropId, crop]) => ({
  label: crop.name,
  value: cropId,
}));

export function buildStorageCropIdRow(args: {
  cropId?: StorageCropId;
  onSelected: (value: StorageCropId) => void;
}): [SimpleCalculatorTableCell, SimpleCalculatorTableCell] {
  const cropLabel = args.cropId ? STORAGE_CROPS[args.cropId].name : 'Select';

  return buildSimpleCalculatorTableRow({
    leftContent: 'Crop',
    rightContent: (
      <Select
        floating
        variant={'table'}
        buttonContent={cropLabel}
        options={storageCropOptions}
        selectedValues={args.cropId ? [args.cropId] : []}
        onOptionSelected={value => args.onSelected(value)}
        buttonClassName={'rounded-tr-2xl'}
      />
    ),
    border: 'top',
    type: 'input',
  });
}

export function parseFloatWithError(strValue: string | undefined) {
  const value = !strValue ? undefined : parseFloat(strValue);
  const error = Number.isNaN(value) || (value !== undefined && value < 0);
  return {
    value: error ? undefined : value,
    error,
  };
}

export function parseMCWithError(strValue: string | undefined, acceptZero: boolean) {
  const parsed = parseFloatWithError(strValue);
  if (parsed.error || parsed.value == undefined) {
    return parsed;
  }
  if (parsed.value < 0 || parsed.value > 100 || (!acceptZero && parsed.value === 0)) {
    return {value: undefined, error: true};
  }

  return parsed;
}
